import {Component, Element, State, h, Prop} from '@stencil/core';

@Component({
  tag: 'uiaas-search-widget-discover-solutions',
  styleUrl: 'discover-solutions-widget.scss',
  shadow: true
})
export class DiscoverSolutionsWidget {

  @Prop() readonly country: string = 'us';
  @Prop() readonly language: string = 'en';
  @Prop() readonly link: string;
  @Prop() readonly appName: string;
  @Prop() readonly anchorTarget: string = '';

  @Element()
    el: HTMLElement;

  @State()
    tabName: string;

  private makeLabel() {
      const language = this.language.toLowerCase();

      switch (language) {
      default:
      case 'en':
        return ['Discover our solutions', 'Maximize energy usage and access energy management solutions anytime.', 'Explore now'];
      case 'de':
        return ['Entdecken Sie unsere Lösungen', 'Maximieren Sie den Energieverbrauch und greifen Sie jederzeit auf Energiemanagementlösungen zu.', 'Jetzt entdecken'];
      case 'pl':
        return ['Poznaj nasze rozwiązania', 'Maksymalizacja zużycia energii i dostęp do rozwiązań do zarządzania energią w dowolnym momencie.', 'Dowiedz się więcej'];
      case 'fr':
        return ['Découvrez nos solutions', 'Optimisez votre consommation d\'énergie et accédez à des solutions de gestion énergétique à tout moment.', 'Découvrir maintenant'];
      case 'ru':
        return ['Откройте для себя наши решения', 'Обеспечьте максимальное энергопотребление и доступ к решениям по управлению энергопотреблением в любое время.', 'Узнать больше'];
      case 'nl':
        return ['Ontdek onze oplossingen', 'Maximaliseer energiegebruik en krijg altijd toegang tot oplossingen voor energiebeheer.', 'Ontdek nu'];
      case 'it':
        return ['Scopri le nostre soluzioni', 'Ottimizza l\'uso dell\'energia e accedi alle soluzioni di gestione energetica in qualunque momento.', 'Esplora ora'];
      case 'sv':
        return ['Upptäck våra lösningar', 'Maximera energianvändningen och få tillgång till energihanteringslösningar när som helst.', 'Utforska nu'];
      case 'es':
        return ['Descubre nuestras soluciones', 'Maximiza el uso de la energía y accede a soluciones de gestión energética en cualquier momento.', 'Explora ahora'];
      case 'ja':
        return ['当社のソリューションを見る', 'エネルギー使用量を最大化し、いつでもエネルギーマネジメントソリューションにアクセスできます。', '詳細はこちら'];
      case 'zh':
        return ['了解我们的解决方案', '最大化能源使用，随时获取能源管理解决方案。', '即刻了解'];
      case 'fi':
        return ['Tutustu ratkaisuihimme', 'Maksimoi energiankulutus ja käytä energianhallintaratkaisuja milloin tahansa.', 'Tutustu nyt'];
      }
  }

  private getLink(): string {
      const link = this.link ? this.link :
        `https://se.com/${this.country}/${this.language}/work/solutions/`;
        
      return link;
  }

  connectedCallback() {
      const closestTabEl = this.el.closest('uiaas-search-tab');
      this.tabName = closestTabEl?.['tabName'];
  }

  render() {
      const labels = this.makeLabel();
      const link = this.getLink();
      return <uiaas-search-cta-widget-v2
        anchor-target={this.anchorTarget}
        tab-name= {this.tabName}
        event-category="Discover our solutions"
        header={labels[0]}
        content={labels[1]}
        url={link}
        buttonText={labels[2]}
      >
        <qds-icon
          slot="icon"
          size="large" 
          name="light-bulb-on"
          className="dashboard-widget-icon"
        />
      </uiaas-search-cta-widget-v2>;
  }
}
